<agpr-popup-dialog
    [id]="'content_library_popup'"
    class="agpr-contentLibraryPopup"
    [positionX]="positionX"
    [positionY]="positionY"
>
    <div
        id="content_library_popup_container"
        class="agpr-contentLibraryPopup-container"
        [style.width]="containerWidth + 'px'"
        (mouseleave)="cancel()"
        (clickOutside)="cancel()"
    >
        <div
            id="content_library_popup_heading"
            class="agpr-contentLibraryPopup-heading"
        >
            <span
                id="content_library_popup_icon"
                class="agpr-contentLibraryPopup-icon fa-regular fa-circle-arrow-up fa-duotone"
                aria-hidden="true"
            ></span>
            {{ 'Common.contentLibrary.info.dialog.heading' | localize}}
        </div>
        <div
            id="content_library_popup_body"
            class="agpr-contentLibraryPopup-content"
        >
            <div
                id="content_library_popup_message"
                class="agpr-contentLibraryPopup-message"
            >{{ 'Common.contentLibrary.info.dialog.message' | localize}}</div>
        </div>
        <div
            id="content_library_popup_actions"
            class="agpr-contentLibraryPopup-button"
        >
            <agpr-button
                [id]="'content_library_contact'"
                label="Common.contentLibrary.info.dialog.contact"
                [style]="buttonTypes.primary"
                [disabled]="loading"
                (click)="openContactUrl()"
            ></agpr-button>
        </div>
    </div>
</agpr-popup-dialog>
